import _ from 'lodash';
import {connect} from 'react-redux';

import {BannerTypesEnum} from '../../../../libs/shared/core/src/store/banners/commonBannerState';
import {
  ErrorBannerTypesEnum,
  SuccessBannerTypesEnum,
} from '../../../../libs/shared/core/src/store/banners/commonBannerTypes';
import {AppPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  AppParametricSelector,
  createShallowEqualSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {hideBannerAction} from '../../../store/panels/app/banners/bannersActions';
import {makeGetVisibleBannersForPanel} from '../../../store/panels/app/banners/bannersSelectors';
import {ContactsManagerBannerState} from '../../../store/panels/app/banners/bannersState';
import {ContactsManagerBanners} from './contactsManagerBanners';

/*
 * Props.
 */

interface ContactsManagerBannersContainerProps {
  panelId: AppPanelId;
}

/*
 * Selectors.
 */

type ContactsManagerBannersSelector = AppParametricSelector<
  ContactsManagerBannersContainerProps,
  ReadonlyArray<ContactsManagerBannerState>
>;

function makeGetSortedBanners(): ContactsManagerBannersSelector {
  return createShallowEqualSelector([makeGetVisibleBannersForPanel()], (visibleBanners) =>
    _(visibleBanners)
      .map((banner) => {
        if (
          (banner.type === BannerTypesEnum.SUCCESS &&
            banner.successType === SuccessBannerTypesEnum.CONTACTS_MANAGER) ||
          (banner.type === BannerTypesEnum.ERROR &&
            banner.errorType === ErrorBannerTypesEnum.CONTACTS_MANAGER)
        ) {
          return banner;
        }

        return undefined;
      })
      .compact()
      .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactsManagerBannersContainerProps>()(() => ({
  banners: makeGetSortedBanners(),
}));

const mapDispatchToProps = makeMapDispatchToProps<ContactsManagerBannersContainerProps>()((props) => ({
  onClose: (bannerId: string) => hideBannerAction(bannerId),
}));

export const ContactsManagerBannersContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactsManagerBanners);
